import rmskincareAPI from '../utils/rmskincareAPI'

const appointmentApi = {
  getAppointment: async (date, endTime = null) => {
    let requestBody = {
      currentTime: date,
    }
    
    // 如果提供了endTime，则添加到请求体中
    if (endTime) {
      requestBody.endTime = endTime
    }
    
    let result = await rmskincareAPI.post('management/appointment/between', requestBody)
    return result.data
  },
  createAppointment: async (data, employeeId) => {
    // console.log("createAppointment",data)
    let result = await rmskincareAPI.post(
      `management/appointment?employeeId=${employeeId}`,
      data
    )
    // console.log(result)
    return result.data
  },

  modifyAppointment: async (data) => {
    let result = await rmskincareAPI.post(
      '/management/appointment/modify',
      data
    )
    return result.data
  },

  deleteAppointment: async (id) => {
    let result = await rmskincareAPI.post(
      `/management/appointment/delete/${id}`
    )
    // console.log(result)
    return result.data
  },

  cancelAppointment: async (id) => {
    let result = await rmskincareAPI.post(
      `/management/appointment/cancel?id=${id}`
    )
    // console.log(result)
    return result.data
  },

  findAppointmentById: async (id) => {
    let result = await rmskincareAPI.post(
      `/management/appointment/findone/${id}`
    )
    // console.log(result.data);
    return result.data
  },

  getRoster: async (isNext) => {
    let result = await rmskincareAPI.post(
      `/management/appointment/getRoster/${isNext}`
    )
    // console.log(result.data)
    return result.data
  },

  findAppointmentByCondition: async (data) => {
    // console.log(data)
    let result = await rmskincareAPI.post(
      '/management/appointment/findAppointment/',
      data
    )
    // console.log(result.data)
    return result.data
  },
  exchangeAppointment: async (data) => {
    let result = await rmskincareAPI.post(
      '/management/appointment/exchangeAppointment/',
      data
    )
    return null
  },
  getAppointmentByEmployee: async (data) => {
    let result = await rmskincareAPI.post(
      '/management/appointment/getAppointmentByEmployee',
      data
    )
    return result.data.data
  },

  /* Room */
  getRoomList: async () => {
    const status = 1
    let result = await rmskincareAPI.get(`/room/list?status=${status}`)
    return result.data.data
  },

  saveRoom: async (requestBody) => {
    let result = await rmskincareAPI.post('/room/save', requestBody)
    return result.data
  },

  updateMessage: async () => {
    let result = await rmskincareAPI.get('/management/appointment/sendMsg')
    // console.log('api result', result)
    return result.data
  },

  getAppointmentListByDate : async (currentDate) => {
    let result = await rmskincareAPI.get(`/management/appointment/rm/findByDate?currentDate=${currentDate}`)
    //  console.log('appointmentListByDate api result', result)
    return result.data.data
  },
}

export default appointmentApi
